var _path, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonalSupport = function SvgPersonalSupport(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 80,
    viewBox: "0 0 108 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 80V64V52H101L76 80Z",
    fill: "#9D9CAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF725E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 32,
    r: 32,
    fill: "#9D9CAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 55.2377C60.1585 49.4054 64 41.1512 64 31.9997C64 22.8483 60.1585 14.5941 54 8.76172C47.8415 14.5941 44 22.8483 44 31.9997C44 41.1512 47.8415 49.4054 54 55.2377Z",
    fill: "#FF9B8D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalSupport);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTA4IiBoZWlnaHQ9IjgwIiB2aWV3Qm94PSIwIDAgMTA4IDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNzYgODBWNjRWNTJIMTAxTDc2IDgwWiIgZmlsbD0iIzlEOUNBQSIvPgo8Y2lyY2xlIGN4PSIzMiIgY3k9IjMyIiByPSIzMiIgZmlsbD0iI0ZGNzI1RSIvPgo8Y2lyY2xlIGN4PSI3NiIgY3k9IjMyIiByPSIzMiIgZmlsbD0iIzlEOUNBQSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTU0IDU1LjIzNzdDNjAuMTU4NSA0OS40MDU0IDY0IDQxLjE1MTIgNjQgMzEuOTk5N0M2NCAyMi44NDgzIDYwLjE1ODUgMTQuNTk0MSA1NCA4Ljc2MTcyQzQ3Ljg0MTUgMTQuNTk0MSA0NCAyMi44NDgzIDQ0IDMxLjk5OTdDNDQgNDEuMTUxMiA0Ny44NDE1IDQ5LjQwNTQgNTQgNTUuMjM3N1oiIGZpbGw9IiNGRjlCOEQiLz4KPC9zdmc+Cg==";